import { createAxios, createAxiosHeaders } from "./axiosHttpMarconi";
export const ticketBaiService = {
  getConfig,
  registerConfig,
  getInvoices,
  downloadXml,
};

function getConfig() {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/fiskaly/ticket-bai`;
  return axios.get(urlPath);
}

function getInvoices(filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/fiskaly/invoices`;
  const params = new URLSearchParams(filters);
  urlPath += `?${params.toString()}`;
  return axios.get(urlPath);
}

function downloadXml(client_id, invoice_id) {
  const axios = createAxiosHeaders();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/fiskaly/invoices/xml`;
  const params = new URLSearchParams({
    client_id,
    invoice_id,
  });
  urlPath += `?${params.toString()}`;
  return axios.get(urlPath, { responseType: "blob" }).then((response) => {
    const contentDisposition = response.headers["content-disposition"];
    const fileName = contentDisposition;
    return Promise.resolve({ blob: response.data, fileName: fileName });
  });
}

function registerConfig(body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/fiskaly/ticket-bai`;
  return axios.post(urlPath, body);
}
